export default "__VITE_ASSET__Bv3x3jfx__"